import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './HeroSlider.css';

function HeroSlider() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSlides();
  }, []);

  const fetchSlides = async () => {
    try {
      const response = await fetch('/api/slides');
      const data = await response.json();
      setSlides(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching slides:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="hero-slider loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (slides.length === 0) {
    return (
      <div className="hero-slider default">
        <div className="hero-content">
          <h1>Καλώς ήρθατε στο Freelancher</h1>
          <p>Η πλατφόρμα για Έλληνες IT Freelancers</p>
          <a href="#categories" className="btn btn-primary">
            Εξερευνήστε Υπηρεσίες
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="hero-slider">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        effect="fade"
        loop={slides.length > 1}
        className="hero-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div 
              className="hero-slide"
              style={{
                backgroundImage: `url(${slide.image})`,
              }}
            >
              <div className="hero-overlay"></div>
              <div className="hero-content">
                <h1 className="hero-title">{slide.title}</h1>
                <h2 className="hero-subtitle">{slide.subtitle}</h2>
                {slide.description && (
                  <p className="hero-description">{slide.description}</p>
                )}
                <a 
                  href={slide.buttonLink} 
                  className="btn btn-primary btn-large"
                >
                  {slide.buttonText}
                </a>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default HeroSlider;
